"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _WebMediaPlayer = _interopRequireDefault(require("./WebMediaPlayer"));
var _PlayerFactory2 = _interopRequireDefault(require("../models/PlayerFactory"));
var _isMobile = _interopRequireDefault(require("../../utils/isMobile"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var WebMediaPlayerFactory = exports["default"] = /*#__PURE__*/function (_PlayerFactory) {
  (0, _inherits2["default"])(WebMediaPlayerFactory, _PlayerFactory);
  function WebMediaPlayerFactory() {
    var _this;
    (0, _classCallCheck2["default"])(this, WebMediaPlayerFactory);
    _this = _callSuper(this, WebMediaPlayerFactory);
    _this.webMediaPlayerMobileInstance = null;
    return _this;
  }

  // mirroring JPlayer behavior for creating a singleton instance for mobile devices
  (0, _createClass2["default"])(WebMediaPlayerFactory, [{
    key: "createPlayer",
    value: function createPlayer() {
      if (!(0, _isMobile["default"])()) {
        return new _WebMediaPlayer["default"]();
      }
      if (!this.webMediaPlayerMobileInstance) {
        this.webMediaPlayerMobileInstance = new _WebMediaPlayer["default"](true);
      }
      return this.webMediaPlayerMobileInstance;
    }
  }]);
  return WebMediaPlayerFactory;
}(_PlayerFactory2["default"]);
//# sourceMappingURL=WebMediaPlayerFactory.js.map